// extracted by mini-css-extract-plugin
export default {"container":"Voucher_container__qoiad","purchaseAt":"Voucher_purchaseAt__IH4KH","tag":"Voucher_tag__tPwWJ"};